export interface INavigation {
  url: string;
  page?: string;
  tab?: string;
  id?: string;
}

export class Navigation implements INavigation {
  url: string;
  page?: string;
  tab?: string;
  id?: string;

  constructor(
    nav: INavigation = {
      url: '',
      page: '',
      tab: '',
      id: '',
    }
  ) {
    const { url, page, tab, id } = nav;

    this.url = url;
    this.page = page;
    this.tab = tab;
    this.id = id;
  }
}
